<script setup>
import {computed} from 'vue'
import {useRouter} from 'vue-router'

import Button from "@/common/Button.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const router = useRouter()
const pageEditorStore = usePageEditorStore()

const contentAreaName = computed(() => pageEditorStore.activeContentAreaName)
const activePageContentId = computed(() => pageEditorStore.activePageContentId)
const pageSectionsNode = computed(() => pageEditorStore.pageSectionsNode)

const setOffcanvas = () => {
    pageEditorStore.offcanvasEnd = false
}

const addSection = async () => {
    const sectionId = await pageEditorStore.addSection()

    await pageEditorStore.goToSection({
        router: router,
        sectionId: sectionId
    })
}
</script>

<template>
    <div v-if="contentAreaName || activePageContentId || pageSectionsNode" class="dropdown">
        <div class="d-inline-block" data-bs-toggle="dropdown">
            <Button class="rounded-0" title="Add content"><i class="bi bi-plus-lg"/></Button>
        </div>

        <ul class="dropdown-menu">
            <li v-if="pageSectionsNode">
                <a @click="addSection" role="button" class="dropdown-item d-flex align-items-center gap-2">
                    <i class="bi bi-plus-lg"/>
                    New section
                </a>
            </li>
            <template v-if="contentAreaName || activePageContentId">
                <li>
                    <a @click="setOffcanvas" data-bs-toggle="offcanvas" href="#addContentOffcanvas" role="button"
                       aria-controls="addContentOffcanvas" class="dropdown-item d-flex align-items-center gap-2">
                        <i class="bi bi-plus-lg"/>
                        New content
                    </a>
                </li>
                <li>
                    <a @click="setOffcanvas" data-bs-toggle="offcanvas" href="#addExistingContentOffcanvas"
                       role="button"
                       aria-controls="addExistingContentOffcanvas"
                       class="dropdown-item d-flex align-items-center gap-2">
                        <i class="bi bi-diagram-3-fill"/>
                        Existing content
                    </a>
                </li>
            </template>
        </ul>
    </div>
</template>